import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import Common from "./Common";
import store from "src/storeWire";
import { event, system_notification } from "../../../store/slice/system";
import CartRepository from "../../../repository/CartRepository";
// import useReduxState from "../../../hooks/useReduxState";
import System from "../../../helper/system";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import liveAuth from 'src/helper/liveAuth';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import { Tooltip } from 'src/component/Tooltip';
import RoleAndPermission from 'src/helper/RoleAndPermission';
import AxiosSingletonLoader from 'src/component/AxiosSingletonLoader,';
import produceClone from "../../../helper/produceClone";
// import useDebounce from "../../../hooks/useDebounce";
import Helper from "../../../support/Helper";
import { __remove, __set } from 'src/store/axios_indicator';
import { SET_ADD_CART_DATA } from 'src/store/slice/model/Cart';
import { useCartStore } from 'src/hooks/cart';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import Constants from 'src/support/Constants';
import useReduxState from 'src/hooks/useReduxState';

const AddToCart = (props) => {
    const addToCartButtonRef = useRef(null);

    const { single_product, isBomPLP, addToBOMSwapModeByBomDetailID, isCompactView, isCompactViewHide, product_detail, contactus, isOnSamePage, hideAdditionalQuoteBtn = false,
        single_product_inventory, special_class_for_add_to_quote, setInvalidQtyInventory, selected_cpn, single_product_pricing_list, disable_add_to_quote,
        disable_add_to_quote_hyperlink_after_add_to_cart, isFrom,
        do_not_display_add_to_cart_button = false } = props;

    const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [searchTerm, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')

    const [disabled_add_to_cart_button, set_disabled_add_to_cart_button] = useState(false);
    const [{ CART_BEFORE_TO_SEND_SERVER, ADD_CART_DATA }, { }, { ADD_TO_CART }] = useCartStore();
    const [{ inventoryList }, { }, { }] = useProductInventoryStore();
    const add_cart_data = ADD_CART_DATA;
    const [_check_p] = useCheckAuthPermissions();
    const [load, setLoad] = useState(false);
    // const [firstServerCall, setFirstServerCall] = useState(true);
    const ItemNumber = single_product.ItemNumber;
    const [__check] = useAxiosIndicatorCheck();
    const orderBlock = System.getOrderBlockCreditRiskFlagBySpeedboat().isOrderBlock;

    useEffect(() => { // optimization done for this code
        async function fetchHere() {
            let status = false;

            const _product = CART_BEFORE_TO_SEND_SERVER[ItemNumber];

            if (_product) {
                if (_product.invalid_quantity !== undefined && _product.invalid_quantity === true) {
                    status = true;
                }

                if (_product.invalid_inventory !== undefined && _product.invalid_inventory === true) {
                    status = true;
                }
                if (_product.obsolete_EOL_invalidate_message_active !== undefined && _product.obsolete_EOL_invalidate_message_active === true) {
                    status = true;
                }

            }

            // if (trigger_obsolete_and_eol_validation_popup && firstServerCall === false) {
            //     set_caller_trigger_obsolete_and_eol_validation_popup(Helper.UUID())
            // }
            if (setInvalidQtyInventory !== undefined) {
                setInvalidQtyInventory(status);
            }
            set_disabled_add_to_cart_button(status)
        }

        fetchHere()
    }, [CART_BEFORE_TO_SEND_SERVER[ItemNumber]])

    // useEffect(() => {
    //     setTimeout(() => {
    //         setFirstServerCall(false)
    //     }, 100);
    // }, []);

    /** 8451 - Loader issue in back button - Pankaj - 03 Feb 2023  */
    useEffect(() => {
        if (add_cart_data === false) {
            setLoad(add_cart_data)
            __remove('CART_API_CALL');
            __remove('ADD_TO_CART_API_CALL');
        }
        if (add_cart_data === true && load === false) {
            setLoad(add_cart_data);
        }
    }, [add_cart_data])

    const addToCartServer = async () => {
        setLoad(true);
        if (disabled_add_to_cart_button === true) {
            setLoad(false);
            return false;
        }

        if (_check_p('PD_ADD_TO_CART').status === false ||
            _check_p('PDT_ADD_TO_CART').status === false ||
            _check_p('CP_ADD_TO_CART').status === false) {
            __remove('CART_API_CALL') // remove API Call
            __remove('CART_OPERATION_API_CALL')
            openContactUsPopup(true);
            return false;
        } else {
            setLoad(true);
            store.dispatch(SET_ADD_CART_DATA(true));
            await addToCart();
        }
    };

    const authLoggedIn = () => {
        return liveAuth.check();
    };

    const addToCart = async () => {
        __set('ADD_TO_CART_API_CALL')

        if (single_product.ERPPartNumber) {
            let inputQty = getQuantityAddToCart();

            let productParam = {
                "quantity": inputQty,
                "currency": window.mct,
                "VendorCode": single_product.VendorCode,
                "SAPMatGroup": single_product.SAPMatgroup,
                "partNumber": single_product.ERPPartNumber,
                "ItemNumber": single_product.ItemNumber,
                "ManufacturerPartNumber": single_product.ManufacturerPartNumber,
                "ManufacturerCode": single_product.ManufacturerCode,
                "ManufacturerName": single_product.ManufacturerName,
                "AssetURL": single_product.AssetURL,
                "type": "Shopping",
                "ERPMFRPartNumber": single_product.ERPMFRPartNumber,
                "ERPManufacturerName": single_product.ERPManufacturerName,
                "ERPManufacturerCode": single_product.ERPManufacturerCode,
                "addedFromBom": false,
                "default_plant": single_product.default_plant,
                "mdmMaterialId": single_product.MDMMaterialID,
                'currentStock': single_product_inventory.quantity,
                'isBackOrder': false,
                'isReplace': false,
                "cpnType": single_product?.CustomerPartNumbers?.length > 0 ? Constants.cpnTypes.CPN : Constants.cpnTypes.MANUALCPN,
                "manualCPN": '',
                "cpn": "",
                isPriceQtyMissMatch: single_product_pricing_list && inputQty < single_product_pricing_list[0].demandQuantityOut
            }

            await new CartRepository().attachCustomerPartNumberBeforeServerCall(productParam);

            let data = {
                "ShortDescription": single_product?.ShortDescription,
                'ObsoleteFlag': single_product?.ObsoleteFlag,
                'EndOfLifeFlag': single_product?.EndOfLifeFlag,
                'FactoryLeadTime': single_product?.FactoryLeadTime,
                "ManufacturerName": single_product.ManufacturerName,
                minQtyPrice: single_product_pricing_list[0]
            }

            const res = await ADD_TO_CART(productParam, isFrom, data, props.customAddToCartButton ? true : false);

            if (res?.data && res?.isSuccessFull && props?.productAddedToCartCallback) {
                setProductSelected({});
                setSearchTerm('');
                if (!res?.data?.isBackOrderConfirmation) {
                    props.productAddedToCartCallback();
                }
                if (isFrom === "Cart" && !res?.data?.isBackOrderConfirmation) {
                    //added by Ramya
                    // updateCartEvent(res); // Analytics code need to mange
                }
            }
            Helper.setEvars(productParam?.ERPMFRPartNumber, "Add to Cart clicked from " + isFrom)

        }
    };

    const getQuantityAddToCart = () => {
        return new Common().getQuantityAddToCart(single_product, CART_BEFORE_TO_SEND_SERVER)
    };

    // const getCartQuantityByERPPartNumber = () => {
    //     return new CartRepository().getQuantityByItemNumber(single_product.ItemNumber)
    // };
    const getDisplayStatusOfAddToCart = () => {
        return new Common().getDisplayStatusOfAddToCart(single_product_pricing_list, single_product, single_product_inventory);
    };
    const getDisplayStatusOfAddToQuote = () => {
        return new Common().getDisplayStatusOfAddToQuote(disable_add_to_quote, single_product_inventory, single_product, single_product_pricing_list);
    };
    const getDisplayStatusOfContactUsButton = () => {
        return new Common().getDisplayStatusOfContactUsButton(disable_add_to_quote, single_product_inventory, single_product, single_product_pricing_list);
    };
    const openContactUsPopup = (val) => {
        store.dispatch(system_notification({
            name: 'ContactUsPopup',
            data: {
                restrict: val != undefined ? val : false,
                order_block: orderBlock,
                addFrom: isFrom
            },
        }));
    };

    const openQuotePopup = () => {
        if (_check_p('PD_CLICK_TO_QUOTE').status === false ||
            _check_p('PDT_CLICK_TO_QUOTE').status === false) {
            openContactUsPopup(true);
            return false;
        }

        /** 11694 # Order Block alert contact us pop-up #Pankaj #20 Dec,2023 */

        if (orderBlock) {
            openContactUsPopup(true);
            return false;
        }
        let single_product_here = produceClone(single_product);
        !authLoggedIn() ? System.popup('GuestPopupActionButton', {
            title: 'Request A Quote',
            body: 'Sign in to request a quote.'
        }) :
            store.dispatch(system_notification({
                name: 'QuotePopup',
                data: {
                    single_product: single_product_here,
                    isOnSamePage: isOnSamePage,
                    selected_cpn: selected_cpn, // 14979
                    addFrom: isFrom
                },
            }));
    };
    const getDisplayStatus = () => {
        if (isBomPLP && isBomPLP === 'yes') {
            return false;
        }
        if (addToBOMSwapModeByBomDetailID && addToBOMSwapModeByBomDetailID === 'yes') {
            return false;
        }
        return true;
    };
    const customAxiosIndicatorRunTimeLoader = () => {
        return (
            load === true &&
            <a href={void (0)} disabled={true}
                className={!isCompactView ? "bs5 btn btn-primary btn-sm w-100 disabled" : "bs5 btn btn-primary btn-sm w-100 disabled"}>
                <i className="fa fa-spinner fa-spin" />
            </a>
        )
    };

    if (props.addToQuoteStatusCallback !== undefined) {
        props.addToQuoteStatusCallback(!getDisplayStatusOfAddToCart());
    }
    const getQuoteUsButton = () => {
        if (props.customQuoteButton !== undefined) {
            return (
                <div onClick={() => {
                    openQuotePopup()
                }}>
                    {React.createElement(props.customQuoteButton)}
                </div>
            )
        }
        return (
            <button onClick={() => {
                openQuotePopup()
            }}
                className={special_class_for_add_to_quote !== undefined ? special_class_for_add_to_quote + ' click-to-quote-btn' : 'bs5 btn btn-primary w-100 click-to-quote-btn'}
            >Click To Quote
            </button>
        )
    };
    const getContactUsButton = () => {
        if (props.customContactUsButton !== undefined) {
            return (
                <div onClick={() => { openContactUsPopup() }}>
                    {React.createElement(props.customContactUsButton)}
                </div>
            )
        }
        return (
            <button onClick={() => {
                openContactUsPopup()
            }}
                className={isCompactView === undefined && isCompactViewHide === undefined ? 'bs5 btn btn-primary w-100 click-to-quote-btn' : 'bs5 btn btn-primary click-to-quote-btn'}
            >Contact Us
            </button>
        )
    };
    const get_AxiosSingletonLoader_disabled_add_to_cart_button = () => {
        let flag = new Common().getObsoleteFailedFlag(single_product, getQuantityAddToCart(), single_product_inventory);
        if (flag === true) {
            return true;
        }

        return disabled_add_to_cart_button;
    };
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);
    const result_AxiosSingletonLoader_disabled_add_to_cart_button = useMemo(() => {
        return get_AxiosSingletonLoader_disabled_add_to_cart_button();
    }, [disabled_add_to_cart_button, single_product, single_product_inventory,
        CART_BEFORE_TO_SEND_SERVER, axios_indicator]);
    return (
        <>
            {
                (getDisplayStatus() &&

                    <div>
                        {getDisplayStatusOfAddToCart() &&
                            <>
                                <AxiosSingletonLoader disabled={result_AxiosSingletonLoader_disabled_add_to_cart_button}
                                    slugKey={['ADD_TO_CART_API_CALL', 'CART_OPERATION_API_CALL', 'VIEW_CART_API_CALL']}
                                    customAxiosIndicatorRunTimeLoader={() => {
                                        return customAxiosIndicatorRunTimeLoader()
                                    }}>
                                    {props.customAddToCartButton &&
                                        <div ref={addToCartButtonRef} onClick={async () => {
                                            await addToCartServer();
                                        }}>
                                            {React.createElement(props.customAddToCartButton)}
                                        </div>
                                    }

                                    {(_check_p('PDG_ADD_TO_CART').status === false || _check_p('PDTG_ADD_TO_CART').status === false) && props.customAddToCartButton === undefined && isCompactViewHide == undefined &&
                                        <Tooltip
                                            position={'bottom center'}
                                            opener={() => (
                                                <a ref={addToCartButtonRef}
                                                    className={!isCompactView ? "bs5 btn btn-primary btn-sm w-100 btn-unauthorize" : "bs5 btn btn-primary btn-sm w-100 add-to-cart-icon btn-unauthorize"}>
                                                    {!isCompactView ? "ADD TO" : ""}
                                                    <i className={isCompactView != undefined && isCompactView ? "fa fa-shopping-cart font-14" : "fa fa-shopping-cart font-14"} />
                                                </a>
                                            )}
                                            content={() => (
                                                <>
                                                    <div
                                                        dangerouslySetInnerHTML={{ __html: RoleAndPermission.guestErrorTooltip() }}>
                                                    </div>
                                                </>
                                            )}
                                        />
                                    }
                                    {props.customAddToCartButton === undefined && (isCompactViewHide == undefined || isCompactViewHide == false) && _check_p('PDG_ADD_TO_CART').status &&
                                        _check_p('PDTG_ADD_TO_CART').status &&
                                        <a disabled={disabled_add_to_cart_button} ref={addToCartButtonRef}
                                            style={{
                                                display: do_not_display_add_to_cart_button ? 'none' : ''
                                            }}
                                            onClick={async () => {
                                                await addToCartServer();
                                            }}
                                            className={`bs5 btn btn-primary btn-sm ${!isCompactView ? 'condense-add-to-cart' : "w-100 add-to-cart-icon"}`}>
                                            {!isCompactView ? "ADD TO" : ""}
                                            <i className={"fa fa-shopping-cart font-14"} />
                                        </a>
                                    }

                                </AxiosSingletonLoader>

                                {!hideAdditionalQuoteBtn && (_check_p('PDG_CLICK_TO_QUOTE').status === false || _check_p('PDTG_CLICK_TO_QUOTE').status === false) && getDisplayStatusOfAddToQuote() && (!isCompactView) && disable_add_to_quote_hyperlink_after_add_to_cart === undefined &&
                                    <Tooltip
                                        position={'bottom center'}
                                        opener={() => (
                                            <div className="mt-2 pt-2 click-to-quote-btn">
                                                {/* <span>Need More? </span> */}
                                                {/* Product listing page does not have need more text. that's why commented */}
                                                <span><a href={void (0)}
                                                    className="text-blue font-bold click-to-qoute-link btn-unauthorize">Click To Quote</a></span>
                                            </div>
                                        )}
                                        content={() => (
                                            <>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: RoleAndPermission.guestErrorTooltip() }}>
                                                </div>
                                            </>
                                        )}
                                    />
                                }

                                {!hideAdditionalQuoteBtn && getDisplayStatusOfAddToQuote() && (!isCompactView) && disable_add_to_quote_hyperlink_after_add_to_cart === undefined &&
                                    _check_p('PDG_CLICK_TO_QUOTE').status && _check_p('PDTG_CLICK_TO_QUOTE').status &&
                                    <div className="mt-2 pt-2 click-to-quote-btn">
                                        {/* <span>Need More? </span> */}
                                        {/* Product listing page does not have need more text. that's why commented */}
                                        <span><a href={void (0)}
                                            className={product_detail !== undefined && product_detail === true ? "text-blue font-bold click-to-qoute-link" : "text-blue font-bold"}
                                            onClick={() => {
                                                openQuotePopup()
                                            }}>Click To Quote</a></span>
                                    </div>
                                }
                            </>
                        }

                        {(_check_p('PDG_CLICK_TO_QUOTE').status === false || _check_p('PDTG_CLICK_TO_QUOTE').status === false) && getDisplayStatusOfAddToQuote() && getDisplayStatusOfAddToCart() === false && (!isCompactView) &&
                            <Tooltip
                                position={'bottom center'}
                                opener={() => (
                                    <button onClick={(e) => { e.preventDefault(); }}
                                        className={special_class_for_add_to_quote ? special_class_for_add_to_quote + ' click-to-quote-btn btn-unauthorize' : 'bs5 btn btn-primary w-100 click-to-quote-btn btn-unauthorize'}
                                    >Click To Quote
                                    </button>)}
                                content={() => (
                                    <>
                                        <div dangerouslySetInnerHTML={{ __html: RoleAndPermission.guestErrorTooltip() }}>
                                        </div>
                                    </>
                                )}
                            />
                        }

                        {getDisplayStatusOfAddToQuote() && getDisplayStatusOfAddToCart() === false && (!isCompactView) &&
                            _check_p('PDG_CLICK_TO_QUOTE').status && _check_p('PDTG_CLICK_TO_QUOTE').status && contactus === undefined &&
                            <>
                                {getQuoteUsButton()}
                            </>
                        }

                        {getDisplayStatusOfContactUsButton() === true &&
                            <>
                                {getContactUsButton()}
                            </>
                        }
                    </div>

                )
            }
        </>
    );
};

export default AddToCart;